/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-children-prop */
import { Avatar } from "@mui/material";
import React from "react";
import styles from "../FamilyDetails.styles";

// member.subscriptions.type === "FDT"

function Structure({ size = 28, center = false, readOnly, subscription }) {
  console.log("subscription", subscription);

  return (
    <div
      style={{
        ...styles.avatarContainer,
        justifyContent: center ? "center" : "flex-start",
      }}
    >
      {subscription[0]?.type === "FDT" ? (
        <Avatar
          style={
            readOnly
              ? {
                  cursor: "default ",
                  ...styles.avatar,
                  width: size,
                  height: size,
                  background: "rgb(4, 61, 144)",
                }
              : {
                  ...styles.avatar,
                  width: size,
                  height: size,
                  background: "rgb(4, 61, 144)",
                  cursor: "pointer",
                }
          }
          children="FDT"
        />
      ) : subscription[0]?.type === "VC" ? (
        <Avatar
          style={
            readOnly
              ? {
                  cursor: "default ",
                  ...styles.avatar,
                  width: size,
                  height: size,
                  background: "rgb(255, 1, 0)",
                }
              : {
                  ...styles.avatar,
                  width: size,
                  height: size,
                  background: "rgb(255, 1, 0)",
                  cursor: "pointer",
                }
          }
          children="VC"
        />
      ) : (
        <Avatar
          style={
            readOnly
              ? {
                  cursor: "default ",
                  ...styles.avatar,
                  width: size,
                  height: size,
                  background: "#808080",
                }
              : {
                  ...styles.avatar,
                  width: size,
                  height: size,
                  background: "#808080",
                  cursor: "pointer",
                }
          }
          children="NA"
        />
      )}
    </div>
  );
}

export default Structure;
